import { useState } from 'react';
import { IconBell, IconArrowBackUp, IconMaximize, IconPlus } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { useToast } from '@hana/ui';
import './i18n';
import { GIVEN_SALE, GST_K } from './given';
import s from './home.module.css';
import g from './given.module.css';

// Mint-Home (1536) · N-04g: khối Việc tôi giao / theo dõi (vai sale) — theo code board given.*: 2 tab, cap 4, ★/☆ theo dõi, Nhắc, Thu hồi.
const CODE_CLS = (c: string): string | undefined => (['PRC', 'SLD', 'OPF', 'DCF', 'QAP'].includes(c) ? s.p : undefined);
const ST = { open: g.sOpen, over: g.sOver, done: g.sDone, wait: g.sWait } as const;

export function Given({ empty }: { empty: boolean }) {
  const t = useT();
  const toast = useToast();
  const tip = (m: string) => toast({ msg: m });
  const [view, setView] = useState<'mine' | 'fol'>('mine');
  const [fol, setFol] = useState<Record<string, boolean>>({});
  const [del, setDel] = useState<Record<string, true>>({});
  const [nud, setNud] = useState<Record<string, number>>({});
  const all = empty ? [] : GIVEN_SALE.filter((r) => !del[r.id]);
  const isFol = (r: { id: string; fol: boolean }) => fol[r.id] ?? r.fol;
  const nMine = all.filter((r) => r.mine).length;
  const nFol = all.filter(isFol).length;
  const list = all.filter((r) => (view === 'fol' ? isFol(r) : r.mine));
  const rows = list.slice(0, 4);
  return (
    <section className={s.my} aria-label={t('hn.gv.aria')}>
      <div className={s.myH}>
        <h2>{t('hn.gv.title')}</h2><span className={s.sum}>{all.filter((r) => r.mine && r.st !== 'done').length} {t('hn.gv.open')}</span>
        <span className={s.grow} />
        <button type="button" className={`${s.bt} ${s.pri}`} aria-haspopup="dialog" onClick={() => tip(t('home.later'))}><IconPlus size={16} stroke={1.8} aria-hidden="true" />{t('hn.gv.assign')}</button>
        <button type="button" className={s.ib} aria-label={t('hn.gv.expandL')} title={t('home.expand')} onClick={() => tip(t('home.later'))}><IconMaximize size={15} stroke={2} aria-hidden="true" /></button>
      </div>
      <div className={`${s.seg} ${g.view}`} role="group" aria-label={t('hn.gv.viewL')}>
        <button type="button" aria-pressed={view === 'mine'} onClick={() => setView('mine')}>{t('hn.gv.tabMine', { n: nMine })}</button>
        <button type="button" aria-pressed={view === 'fol'} onClick={() => setView('fol')}>{t('hn.gv.tabFol', { n: nFol })}</button>
      </div>
      {!rows.length && <div className={s.none}>{t('hn.gv.none')}</div>}
      {rows.map((r) => {
        const f = isFol(r);
        const n = nud[r.id] ?? 0;
        return (
          <div key={r.id} className={g.row}>
            <button type="button" className={g.star} aria-pressed={f} title={f ? t('hn.gv.unfol') : t('hn.gv.follow')} onClick={() => { setFol((x) => ({ ...x, [r.id]: !f })); tip(f ? t('hn.gv.unfolDone', { c: r.code }) : t('hn.gv.folDone', { c: r.code })); }}>{f ? '★' : '☆'}</button>
            <span className={`${s.code} ${CODE_CLS(r.code)}`} title={r.code}>{r.code}</span>
            <div className={s.rb}><div className={s.rt}>{r.title}</div><div className={g.sub}>{t('hn.gv.sub', { o: r.obj, w: r.who, d: r.due })}</div></div>
            <span className={`${g.st} ${ST[r.st]}`}>{GST_K[r.st]}</span>
            {r.st !== 'done' && <button type="button" className={s.bt} onClick={() => { setNud((x) => ({ ...x, [r.id]: n + 1 })); tip(t('hn.gv.nudged', { w: r.who, c: r.code })); }}><IconBell size={16} stroke={1.8} aria-hidden="true" />{n ? t('hn.gv.nudgeN', { n }) : t('hn.gv.nudge')}</button>}
            {r.mine && r.st !== 'done' && <button type="button" className={s.bt} onClick={() => { setDel((x) => ({ ...x, [r.id]: true })); tip(t('hn.gv.recalled', { c: r.code })); }}><IconArrowBackUp size={16} stroke={1.8} aria-hidden="true" />{t('hn.gv.recall')}</button>}
          </div>
        );
      })}
    </section>
  );
}
